import { useState, type ReactElement } from 'react';
// Contexts
import { useUser } from '@utmb/contexts/AuthContext';
// Components
import { IndexStatistics } from '../index-statistics/index-statistics';
import { IndexDistribution } from '../index-ranking-distribution/index-distribution';
// Types
import { PiCategoryEnum } from '@utmb/types/enum/PiCategoryEnum';
import RaceYearResultForRunnerView from '@utmb/types/view/RaceYearResultForRunnerView';
import RunnerStatisticView from '@utmb/types/view/RunnerStatisticView';
// Styles
import styles from './index-charts-area.module.scss';

const VALID_CATEGORIES = [PiCategoryEnum.PI20K, PiCategoryEnum.PI50K, PiCategoryEnum.PI100K, PiCategoryEnum.PI100M];

export interface IndexChartsAreaProps {
    results: RaceYearResultForRunnerView[];
    runnerStatistic?: RunnerStatisticView | null;
    runnerUri?: string;
    profilePicture?: string | null;
    fullname?: string;
}

export function IndexChartsArea({
    results,
    runnerStatistic = null,
    runnerUri,
    profilePicture = null,
    fullname,
}: IndexChartsAreaProps): ReactElement {
    const { isAuthenticated } = useUser();
    const [selectedCategory, setSelectedCategory] = useState<PiCategoryEnum>(PiCategoryEnum.GENERAL);

    // Finisher-only results (index ≤ threshold) are kept: they count as finished races in
    // the key figures; IndexStatistics leaves them out of the chart.
    const categorizedResults = results.filter((r) => VALID_CATEGORIES.includes(r.piCategory));

    return (
        <div className={styles.indexChartsArea}>
            <IndexStatistics
                results={categorizedResults}
                selectedCategory={selectedCategory}
                onCategoryChange={setSelectedCategory}
                isAuthenticated={!!isAuthenticated}
            />
            {isAuthenticated ? (
                <IndexDistribution runnerStatistic={runnerStatistic} runnerUri={runnerUri} profilePicture={profilePicture} fullname={fullname} />
            ) : null}
        </div>
    );
}
